module.exports = __webpack_public_path__ + "media/1.351d23f2.mp4";